export default __webpack_public_path__ + "static/media/TubeStand-shorter.f81ab83e.svg";